import React from 'react';
import styles from './TableContent.module.scss';
// import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip } from '@/components/TableCell';

class TableContent extends React.Component {

    _takeColumns = () => ([
        {
            title: '组织架构层级',
            dataIndex: 'deptName',
            key: 'deptName',
            width: '10%',
            align: 'left',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '归属',
            dataIndex: 'parentName',
            key: 'parentName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '主负责人',
            dataIndex: 'principalsName',
            key: 'principalsName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '电话',
            dataIndex: 'principalsTel',
            key: 'principalsTel',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '人数',
            dataIndex: 'emplCount',
            key: 'emplCount',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作人',
            dataIndex: 'modifyUserName',
            key: 'modifyUserName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            width: '10%',
            render: (text, item) => this._renderActionCell(item)
        }
    ]);

    _takeDataSource = (dataList) => {
        if (Array.isArray(dataList)) {
            return dataList;
        } else {
            return [];
        }
    }

    _renderActionCell = (item) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction('edit', item)}>编辑</div>
                <div className={styles.item} onClick={() => tableAction('delete', item)}>删除</div>
            </div>
        );
    }

    render() {
        // const { paginationChange } = this.props;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this._takeColumns()}
                    dataSource={this._takeDataSource(this.props.renderData)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                {/* <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                /> */}
            </div>
        );
    }
}

TableContent.propTypes = {
    renderData: PropTypes.array.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    // paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableContent;